import { render, staticRenderFns } from "./PointingResults.vue?vue&type=template&id=c6e9454a&"
import script from "./PointingResults.vue?vue&type=script&lang=ts&"
export * from "./PointingResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports